const AUSTRALIA_COUNTRY_META = {
  id: 14,
  country_name: "Australia",
  country_code_2: "AU",
  country_code_3: "AUS",
  chinese_name: "澳大利亚",
  tel_area_code: "61",
  position: 386,
  status: 1,
  has_state: 1,
  created_at: 1628043066,
  updated_at: 1628043066,
  continent: "OA",
  default_currency: "AUD",
  postcode_config: "{\"format\":\"2060\",\"regular_expression\":\"/^\\\\d{4}$/\",\"config\":{\"need\":\"1\",\"check\":\"1\"}}",
  local_name: "Australia",
};

const AUSTRALIA_ADDRESS_LIBRARY_SOURCE = [
  {
    divisionName: "New South Wales",
    code: "NSW",
    childrenAddress: [
      {
        divisionName: "Sydney",
        code: "SYD",
        childrenAddress: [
          { divisionName: "Sydney CBD", code: "2000" },
          { divisionName: "Parramatta", code: "2150" },
          { divisionName: "Chatswood", code: "2067" },
          { divisionName: "Bondi Junction", code: "2022" },
        ],
      },
      {
        divisionName: "Newcastle",
        code: "NTL",
        childrenAddress: [
          { divisionName: "Newcastle", code: "2300" },
          { divisionName: "Maitland", code: "2320" },
          { divisionName: "Charlestown", code: "2290" },
        ],
      },
      {
        divisionName: "Wollongong",
        code: "WOL",
        childrenAddress: [
          { divisionName: "Wollongong", code: "2500" },
          { divisionName: "Shellharbour", code: "2529" },
          { divisionName: "Kiama", code: "2533" },
        ],
      },
    ],
  },
  {
    divisionName: "Victoria",
    code: "VIC",
    childrenAddress: [
      {
        divisionName: "Melbourne",
        code: "MEL",
        childrenAddress: [
          { divisionName: "Melbourne CBD", code: "3000" },
          { divisionName: "Carlton", code: "3053" },
          { divisionName: "Footscray", code: "3011" },
          { divisionName: "Dandenong", code: "3175" },
        ],
      },
      {
        divisionName: "Geelong",
        code: "GEX",
        childrenAddress: [
          { divisionName: "Geelong", code: "3220" },
          { divisionName: "Belmont", code: "3216" },
          { divisionName: "Grovedale", code: "3216" },
        ],
      },
      {
        divisionName: "Ballarat",
        code: "BAL",
        childrenAddress: [
          { divisionName: "Ballarat Central", code: "3350" },
          { divisionName: "Wendouree", code: "3355" },
          { divisionName: "Delacombe", code: "3356" },
        ],
      },
    ],
  },
  {
    divisionName: "Queensland",
    code: "QLD",
    childrenAddress: [
      {
        divisionName: "Brisbane",
        code: "BNE",
        childrenAddress: [
          { divisionName: "Brisbane City", code: "4000" },
          { divisionName: "South Brisbane", code: "4101" },
          { divisionName: "Fortitude Valley", code: "4006" },
          { divisionName: "Chermside", code: "4032" },
        ],
      },
      {
        divisionName: "Gold Coast",
        code: "OOL",
        childrenAddress: [
          { divisionName: "Southport", code: "4215" },
          { divisionName: "Surfers Paradise", code: "4217" },
          { divisionName: "Broadbeach", code: "4218" },
        ],
      },
      {
        divisionName: "Cairns",
        code: "CNS",
        childrenAddress: [
          { divisionName: "Cairns City", code: "4870" },
          { divisionName: "Smithfield", code: "4878" },
          { divisionName: "Gordonvale", code: "4865" },
        ],
      },
    ],
  },
  {
    divisionName: "Western Australia",
    code: "WA",
    childrenAddress: [
      {
        divisionName: "Perth",
        code: "PER",
        childrenAddress: [
          { divisionName: "Perth CBD", code: "6000" },
          { divisionName: "Fremantle", code: "6160" },
          { divisionName: "Joondalup", code: "6027" },
          { divisionName: "Subiaco", code: "6008" },
        ],
      },
      {
        divisionName: "Mandurah",
        code: "MDU",
        childrenAddress: [
          { divisionName: "Mandurah", code: "6210" },
          { divisionName: "Halls Head", code: "6210" },
          { divisionName: "Falcon", code: "6210" },
        ],
      },
      {
        divisionName: "Bunbury",
        code: "BUY",
        childrenAddress: [
          { divisionName: "Bunbury", code: "6230" },
          { divisionName: "Australind", code: "6233" },
          { divisionName: "Eaton", code: "6232" },
        ],
      },
    ],
  },
  {
    divisionName: "South Australia",
    code: "SA",
    childrenAddress: [
      {
        divisionName: "Adelaide",
        code: "ADL",
        childrenAddress: [
          { divisionName: "Adelaide CBD", code: "5000" },
          { divisionName: "Glenelg", code: "5045" },
          { divisionName: "Norwood", code: "5067" },
          { divisionName: "Prospect", code: "5082" },
        ],
      },
      {
        divisionName: "Mount Gambier",
        code: "MGD",
        childrenAddress: [
          { divisionName: "Mount Gambier", code: "5290" },
          { divisionName: "Suttontown", code: "5291" },
          { divisionName: "Compton", code: "5291" },
        ],
      },
      {
        divisionName: "Whyalla",
        code: "WYA",
        childrenAddress: [
          { divisionName: "Whyalla", code: "5600" },
          { divisionName: "Whyalla Norrie", code: "5608" },
          { divisionName: "Whyalla Stuart", code: "5608" },
        ],
      },
    ],
  },
  {
    divisionName: "Tasmania",
    code: "TAS",
    childrenAddress: [
      {
        divisionName: "Hobart",
        code: "HBA",
        childrenAddress: [
          { divisionName: "Hobart", code: "7000" },
          { divisionName: "Battery Point", code: "7004" },
          { divisionName: "Sandy Bay", code: "7005" },
        ],
      },
      {
        divisionName: "Launceston",
        code: "LST",
        childrenAddress: [
          { divisionName: "Launceston", code: "7250" },
          { divisionName: "Invermay", code: "7248" },
          { divisionName: "Newstead", code: "7250" },
        ],
      },
      {
        divisionName: "Devonport",
        code: "DPO",
        childrenAddress: [
          { divisionName: "Devonport", code: "7310" },
          { divisionName: "East Devonport", code: "7310" },
          { divisionName: "Miandetta", code: "7310" },
        ],
      },
    ],
  },
  {
    divisionName: "Australian Capital Territory",
    code: "ACT",
    childrenAddress: [
      {
        divisionName: "Canberra",
        code: "CBR",
        childrenAddress: [
          { divisionName: "Canberra City", code: "2601" },
          { divisionName: "Belconnen", code: "2617" },
          { divisionName: "Gungahlin", code: "2912" },
          { divisionName: "Woden", code: "2606" },
        ],
      },
      {
        divisionName: "Tuggeranong",
        code: "TGG",
        childrenAddress: [
          { divisionName: "Greenway", code: "2900" },
          { divisionName: "Kambah", code: "2902" },
          { divisionName: "Calwell", code: "2905" },
        ],
      },
    ],
  },
  {
    divisionName: "Northern Territory",
    code: "NT",
    childrenAddress: [
      {
        divisionName: "Darwin",
        code: "DRW",
        childrenAddress: [
          { divisionName: "Darwin City", code: "0800" },
          { divisionName: "Casuarina", code: "0810" },
          { divisionName: "Palmerston", code: "0830" },
        ],
      },
      {
        divisionName: "Alice Springs",
        code: "ASP",
        childrenAddress: [
          { divisionName: "Alice Springs", code: "0870" },
          { divisionName: "Sadadeen", code: "0870" },
          { divisionName: "Braitling", code: "0870" },
        ],
      },
    ],
  },
];

function buildNodeId(countryCode2 = "", path = []) {
  const prefix = String(countryCode2 || "").trim().toUpperCase() || "LOCAL";
  const suffix = path
    .map((item) => String(item || "").trim().replace(/\s+/g, "-"))
    .filter(Boolean)
    .join("-");

  return suffix ? `${prefix}-${suffix}` : prefix;
}

function toAddressNode(rawNode, meta, path = [], level = 2, parentId = "0") {
  const divisionName = String(rawNode.divisionName || "");
  const currentPath = [...path, divisionName];
  const id = buildNodeId(meta.country_code_2, currentPath);
  const rawChildren = Array.isArray(rawNode.childrenAddress) ? rawNode.childrenAddress : [];

  return {
    id,
    divisionName,
    code: String(rawNode.code || ""),
    divisionLevel: level,
    parentId,
    status: meta.status,
    country: meta.country_code_2,
    countryName: meta.country_name,
    countryCode2: meta.country_code_2,
    countryCode3: meta.country_code_3,
    chineseName: meta.chinese_name,
    localName: meta.local_name,
    defaultCurrency: meta.default_currency,
    telAreaCode: meta.tel_area_code,
    continent: meta.continent,
    postcodeConfig: meta.postcode_config,
    childrenAddress: rawChildren.map((item) =>
      toAddressNode(
        typeof item === "string" ? { divisionName: item } : item,
        meta,
        currentPath,
        level + 1,
        id
      )
    ),
  };
}

function buildAddressLibrary(meta, nodes = []) {
  const countryName = String(meta.country_name || meta.local_name || meta.country_code_2 || "");
  const countryId = buildNodeId(meta.country_code_2, [countryName]);

  return [
    {
      id: countryId,
      divisionName: countryName,
      code: String(meta.country_code_2 || ""),
      divisionLevel: 1,
      parentId: "0",
      status: meta.status,
      country: meta.country_code_2,
      countryName: meta.country_name,
      countryCode2: meta.country_code_2,
      countryCode3: meta.country_code_3,
      chineseName: meta.chinese_name,
      localName: meta.local_name,
      defaultCurrency: meta.default_currency,
      telAreaCode: meta.tel_area_code,
      continent: meta.continent,
      postcodeConfig: meta.postcode_config,
      childrenAddress: nodes.map((node) =>
        toAddressNode(node, meta, [countryName], 2, countryId)
      ),
    },
  ];
}

const LOCAL_ADDRESS_LIBRARY_MAP = {
  australia: {
    meta: AUSTRALIA_COUNTRY_META,
    tree: buildAddressLibrary(AUSTRALIA_COUNTRY_META, AUSTRALIA_ADDRESS_LIBRARY_SOURCE),
  },
};

export function getLocalAddressLibrary(dataset = "") {
  const key = String(dataset || "").trim().toLowerCase();
  const library = LOCAL_ADDRESS_LIBRARY_MAP[key]?.tree;

  if (!Array.isArray(library)) {
    return [];
  }

  return JSON.parse(JSON.stringify(library));
}

export function getLocalAddressLibraryMeta(dataset = "") {
  const key = String(dataset || "").trim().toLowerCase();
  const meta = LOCAL_ADDRESS_LIBRARY_MAP[key]?.meta;

  if (!meta || typeof meta !== "object") {
    return null;
  }

  return JSON.parse(JSON.stringify(meta));
}

export default {
  getLocalAddressLibrary,
  getLocalAddressLibraryMeta,
};
